<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Calendar') }}</h4>
        </div>
        <div class="btn-row">
          <div class="btn-group">
            <button
              type="button"
              class="btn"
              @click="changeAllEvents(false)"
              :class="allEvents?'btn-light':'btn-dark'">
              {{ $t('Mine') }}
              </button>
            <button
              type="button"
              class="btn"
              @click="changeAllEvents(true)"
              :class="allEvents?'btn-dark':'btn-light'">
              {{ $t('All') }}
              </button>
          </div>
        </div>
      </div>

    </div>

    <div class="vflex-row-1" ref="calendarMain">
      
      <div :class="{'box-loading': loading}">
        <full-calendar
          :config="fullCalendarConfig"
          :event-sources="eventSources"
          ref="calendar">
          </full-calendar>
      </div>
      
      <calendar-event
        v-if="eventId"
        :eventId="eventId"
        @hideModal="hideEvent">
        </calendar-event>
        
    </div>

  </div>

</template>

<script>
import { FullCalendar } from 'vue-full-calendar'
import 'fullcalendar/dist/locale/pt-br'
import 'fullcalendar/dist/locale/en-gb'
import 'fullcalendar/dist/fullcalendar.css'
import moment from 'moment'

import CalendarEvent from './CalendarEvent'

export default {
  name: 'Calendar',
  components: {
    FullCalendar,
    CalendarEvent
  },
  data () {
    return {
      loading: true,
      fullCalendarConfig: {
        locale: this.$i18n.locale ? this.$i18n.locale.toLowerCase() : undefined, // 'pt-br'
        windowResize: this.resize,
        eventClick: (calEvent, jsEvent, view) => {
          if (calEvent.internal) {
            this.showEvent(calEvent._id)
          }
        },
        header: {
          left: 'prev,next today',
          center: 'title',
          right: 'month,agendaWeek,agendaDay'
        },
        defaultView: this.$route.query.type || 'agendaWeek',
        defaultDate: this.$route.query.default_date || null,
        editable: false, // disable aditable
        selectable: false, // disable add
        navLinks: true, // can click day/week names to navigate views
        eventLimit: true, // allow "more" link when too many events
        scrollTime: '06:00:00',
        // contentHeight: 'auto',
        // height: 300,
        // defaultDate: '2017-06-01',
        // buttonIcons: false, // show the prev/next text
        // weekNumbers: false,
        viewRender: (view, element) => {
          this.$changeUrlParam({
            type: view.type,
            default_date: moment(view.intervalStart).toISOString()
          })
        }
      },
      eventSources: [{
        events: (start, end, timezone, callback) => {
          this.loading = true
          const startDate = moment(start).tz(moment.tz.guess()).toISOString()
          const endDate = moment(end).tz(moment.tz.guess()).toISOString()
          const filters = {
            start_at: 'd|' + [startDate, endDate].join('|')
          }

          if (!this.allEvents) {
            // filters['participants.email'] = this.$store.getters.getMe.email
            filters['assigned_users'] = this.$store.getters.getMe._id
          }

          return this.$store
          .dispatch('selectCalendarEvents', filters)
          .then((result) => {
            callback(result.map(event => {
              return {
                _id: event._id,
                internal: event.internal,
                title: event.summary,
                start: moment(event.start_at),
                end: moment(event.start_at).add(event.duration, 'minutes'),
                color: event.my_event ? '#ffc107' : '#007bff',
                className: 'eventClick'
              }
            }))
            this.loading = false
          })
        }
        // color: 'yellow',
        // textColor: 'black'
      }]
    }
  },
  computed: {
    eventId () {
      return this.$route.query.event_id
    },
    allEvents () {
      return this.$route.query.all_events
    }
  },
  metaInfo () {
    return {
      title: this.$t('Calendar')
    }
  },
  mounted () {
    this.resize()
  },
  methods: {
    resize () {
      if (this.$refs.calendar) {
        const winHeight = isNaN(window.innerHeight) ? window.clientHeight : window.innerHeight
        const calHeight = winHeight - this.$refs['calendarMain'].offsetTop
        this.$refs.calendar.fireMethod('option', 'height', calHeight)
      }
    },
    showEvent (id) {
      this.$changeUrlParam({
        event_id: id
      })
    },
    hideEvent () {
      this.$changeUrlParam({
        event_id: undefined
      })
    },
    changeAllEvents (allEvents) {
      this.$changeUrlParam({
        all_events: allEvents || undefined
      })
      this.$refs.calendar.fireMethod('refetchEvents')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.eventClick{
  cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar/Calendar.vue